<template>
    <el-button type="text">
        <span v-if="['string', 'detailstr'].includes(fieldobj.type)">
            <el-input v-if="inputVisible" class="input-new-tag" size="mini" v-model="inputValue" ref="headinput"
                :placeholder="fieldobj.title" @keyup.enter.native="handleInputConfirm(inputValue)"
                @blur="blur(inputValue)"></el-input>
            <span v-else>
                <el-tag type="success" v-if="inputValue" closable @close="inputValue = ''; handleInputConfirm('')"
                    @click="showInput">{{ inputValue }}
                </el-tag>
                <span v-else class="thetitle" @click="showInput">{{ fieldobj.title }}</span>
            </span>
        </span>
        <span v-if="!['string', 'detailstr'].includes(fieldobj.type)" @click="headerclick(fieldobj)"
            style=" font-weight: bold;vertical-align: middle;color: black;">
            {{ fieldobj.title }}
        </span>
        <span v-if="fieldobj.filterable != 'no'" @click="headerclick(fieldobj)" v-bind:class="sortclass"></span>
    </el-button>
</template>
<style>
.input-new-tag {
    width: 90px;
    /* margin-left: 10px; */
    vertical-align: middle;
}

.thetitle {
    font-weight: bold;
    vertical-align: middle;
    color: black
}
</style>
  
<script>
export default {
    props: ["fieldobj", "defaultval", "defaultsortval"],
    data() {
        return {
            inputVisible: false,
            inputValue: this.defaultval || "",
            fieldsortval: this.defaultsortval,
            matchrule: {},
            sortset: {},
            sortclass: { 'el-icon-sort': this.defaultsortval == undefined, 'el-icon-arrow-up bg-success text-white': this.defaultsortval == 1, 'el-icon-arrow-down bg-danger text-white': this.defaultsortval == -1 }
        };
    },


    computed: {

    },
    watch: {
        //matchrulestatus是为了在savesearch toeval中直接设置matchrule时fieldhead能够相应变化而设置的
        defaultval(newval, oldVal) {
            // console.log(this.inputValue==newval)
            if (this.inputValue != newval) {
                this.inputValue = newval//this.$store.state.matchrule[this.name] 
            }

        }
    },
    methods: {

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.headinput.$refs.input.focus();
            });
        },

        fieldheadset() {
  
            this.$emit("fieldheadset", { matchrule: this.matchrule, sortset: this.sortset, currentfield: this.fieldobj })
        },

        blur(val) {
            if (val == "") {
                this.handleInputConfirm(val)
            }
        },

        handleInputConfirm(val) {
            this.inputVisible = false;

            this.matchrule[this.fieldobj.name] = this.inputValue



            this.fieldheadset()

        },

        headerclick(x) {
            if (x.filterable != "no") {
                this.tablesort(x);
                this.sortset[this.fieldobj.name] = this.fieldsortval
                this.fieldheadset()
            }

            else if (x.name === "edit") {
                this.$store.state.items.forEach((obj) => {
                    if (!this.$store.state.editsid.includes(obj._id)) {
                        this.$store.commit("setedits", obj);
                    }
                });
            }
            else if(x.name==="printout"){
                this.$store.state.items.forEach((obj) => {
                    this.$store.commit("setprint", obj)
                    // if (!this.$store.state.editsid.includes(obj._id)) {
                    //     this.$store.commit("setedits", obj);
                    // }
                });

            }
            else if (x.name === "tick") {
                this.$store.state.items.forEach((obj) => {
                    this.$store.commit("setmodify", obj);
                });
            }
        },
        tablesort(x) {
            switch (this.fieldsortval) {
                case undefined:
                    this.fieldsortval = 1
                    this.sortclass = { 'el-icon-arrow-up bg-success text-white': true }
                    break;
                case 1:
                    this.fieldsortval = -1
                    this.sortclass = { 'el-icon-arrow-down bg-danger text-white': true }
                    break;
                case -1:
                    this.fieldsortval = undefined
                    this.sortclass = { 'el-icon-sort': true }
                    return;
            }
            // if(x.type=="string"){
            this.currentfield = x
            // }


        },

    }
};
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/table_header_fieldhead.vue